import { render, staticRenderFns } from "./HomePortalSection.vue?vue&type=template&id=f8bb66c6&scoped=true"
import script from "./HomePortalSection.vue?vue&type=script&lang=js"
export * from "./HomePortalSection.vue?vue&type=script&lang=js"
import style0 from "./HomePortalSection.vue?vue&type=style&index=0&id=f8bb66c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb66c6",
  null
  
)

export default component.exports